import {useEffect, useState} from 'react';

import {AnalyticsVisualization} from 'insights/analytics-visualizations/__generated/AnalyticsVisualization';
import {VisualizationTypeToParameters} from 'insights/analytics-visualizations/AnalyticsVisualizationTypes';
import getVisualizationType from 'insights/analytics-visualizations/data/getVisualizationType';

export type VisualizationParametersByType = Partial<VisualizationTypeToParameters>;

/**
 * Locally save the previous parameters for each type
 *
 * That way, if the user changes from line chart to table to line chart, we can restore the previously
 * selected parameters instead of initializing the default ones.
 */
export default function usePreviousVisualizationParametersByType(
  currentVisualization: AnalyticsVisualization | null
): VisualizationParametersByType {
  const [parametersByType, setParametersByType] = useState<VisualizationParametersByType>({});

  useEffect(() => {
    if (currentVisualization == null) {
      return;
    }

    setParametersByType((parametersByTypeArg) => ({
      ...parametersByTypeArg,
      [getVisualizationType(currentVisualization)]: currentVisualization.parameters,
    }));
  }, [currentVisualization]);

  return parametersByType;
}
